import { render } from "./AppFooter.vue?vue&type=template&id=5b1198d1&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "@/Common/Styles/AppFooter.scss?vue&type=style&index=0&id=5b1198d1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1198d1"]])

export default __exports__